import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rutMusk',
  standalone: false
})
export class RutMuskPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      value = value.replace(/[.-]/g, '');
      let result: string;
      let verificador = value.slice(-1);
      switch (value.length) {
        case 8: {
          result = this.parse1MRut(value, verificador);
          break;
        }
        case 9: {
          result = this.parse2MRut(value, verificador);
          break;
        }
        default: {
          result = value;
          break;
        }
      }
      return result;
    }
    return value;
  }

  private parse1MRut(value: string, verificador: string) {
    let millones = value.slice(0, 1);
    let miles = value.slice(1, 4);
    let cent = value.slice(4, 7);
    let newValue: string =
      millones + '.' + miles + '.' + cent + '-' + verificador;
    return newValue;
  }

  private parse2MRut(value: string, verificador: string) {
    let millones = value.slice(0, 2);
    let miles = value.slice(2, 5);
    let cent = value.slice(5, 8);
    let newValue: string =
      millones + '.' + miles + '.' + cent + '-' + verificador;
    return newValue;
  }
}
